/** Shared date formatting for the v2 surfaces. Kept here rather than on a page so
 *  the billing row, the eVault drive's off-dialog and the toast that confirms the
 *  switch-off all quote the SAME cycle-end date the same way — three renderings of
 *  one date reading three different ways is how a customer decides they were told
 *  two different things. */
export const fmtDate = (ms?: number | null) => {
	if (!ms) return '—';
	const d = new Date(ms);
	if (Number.isNaN(d.getTime())) return '—';
	return d.toLocaleDateString(undefined, {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	});
};
